const transformToHeatMap = (data, nameKey, xKey, yKey) => {
    const cache = {};
    const result = {
        series: [],
        categories: [...new Set(data.map((item) => item[xKey]))],
    };
    const series = [];
    let i = 0;
    data.forEach((item) => {
        const name = item[nameKey];
        const x = item[xKey];
        const y = item[yKey];
        if(!cache[name]) {
            cache[name] = i;
            
            series[i] = {
                name,
                data:[],
            }
            i++;
        }
        series[cache[name]].data.push(
            {
                x,
                y,
            }
        )
    });
    result.series = series;
    return result;
};


const transformFeatures = (data, nameKey, xValue, yValue) => {
    const cache = {};
    const result = {
        series: [],
        labels: [...new Set(data.map((item) => item[nameKey]))],
    };
    const series = [];
    let i = 0;
    const xValues = data.filter((item) => item.attribute == xValue);
    const yValues = data.filter((item) => item.attribute == yValue)

    xValues.forEach((item) => {
        const name = item[nameKey];
        if(!cache[name]) {
            cache[name] = i;
            series[i] = [0, 0];
            i++;
        }
        series[cache[name]][0] = parseFloat(item.attribute_value);
    });
    yValues.forEach((item) => {
        const name = item[nameKey];
        if(!cache[name]) {
            cache[name] = i;
            series[i] = [0, 0];
            i++;
        }
        series[cache[name]][1] = parseFloat(item.attribute_value);
    });
    result.series = series;
    return result;
};
export {
    transformToHeatMap,
    transformFeatures,
};